import { render, staticRenderFns } from "./BonusSetting.vue?vue&type=template&id=29cc7ab2&"
import script from "./BonusSetting.vue?vue&type=script&lang=js&"
export * from "./BonusSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports